import axios from 'axios';
import { store }from '../store';

const secure_axios = axios.create();

// Request interceptor for API calls
secure_axios.interceptors.request.use(
  async config => {
    const access_token = store.getters.authToken
    const company = config.headers.Company || store.getters.company
    config.headers = { 
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${access_token}`,
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Company' : company
    }
    return config;
  },
  error => {
    Promise.reject(error)    
});

// Response interceptor for API calls
secure_axios.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;  
  if (error.response?.status === 401){
    originalRequest._retry = true;
    store.dispatch("signUserOut") 
    window.location.href="/";
    return Promise.reject(false);
  }
  if (error.response?.status === 403 && !originalRequest._retry) {    
    let old_token = store.getters.authToken    
    await store.dispatch("refreshToken")   
    const access_token = store.getters.authToken 
    originalRequest._retry = (old_token != access_token) ;  
    // console.log(originalRequest._retry)  
    store.dispatch("auth_error",error)     
    return secure_axios(originalRequest);
  }
  return Promise.reject(error);
});


export default secure_axios

